module.exports = __webpack_public_path__ + "static/img/十大创新奖.7b5b908a.png";